module.exports = __webpack_public_path__ + "img/tele2.42a38f96.svg";